module.exports = __webpack_public_path__ + "/login_ui/img/bm-ed0c88a223813354130aafcbfdf6ade3.svg";